import authSk from "./authSk";
import commonSk from "./commonSk";
import footerSk from "./footerSk";
import gallerySk from "./gallerySk";
import menuSk from "./menuSk";
import navigationSk from "./navigationSk";
import orderSk from "./orderSk";
import paymentSk from "./paymentSk";
import statisticsSk from "./statisticsSk";

const mainSk = {
    common: commonSk,
    navigation: navigationSk,
    menu: menuSk,
    statistics: statisticsSk,
    order: orderSk,
    payment: paymentSk,
    auth: authSk,
    gallery: gallerySk,
    footer: footerSk,
};

export default mainSk;
